<template>
  <div>
    <Navbar/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idRespuesta" class="form-label">IdRespuesta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idRespuesta" name="idRespuesta" v-model="datoRespuesta.idRespuesta" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripcion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="descripcion" name="descripcion" v-model="datoRespuesta.descripcion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarRespuesta" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditRespuesta" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdPlaDetObs</th>
          <th scope="col">IdPlanillaDet</th>
          <th scope="col">IdObservacion</th>
          <th scope="col">IdRespuesta</th>
          <th scope="col">Descripcion</th>
          <th scope="col">Respuesta</th>
          <th scope="col">Estado</th>
          <th scope="col">ObservacionDescripcion</th>
          <th scope="col">RespuestaDescripcion</th>
          <th scope="col">PlanillaDetDescripcion</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pladetobs in datosPaginados" :key="pladetobs.idPlaDetObs">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(pladetobs.idPlaDetObs)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(pladetobs.idPlaDetObs)" title="Editar">edit_square</i></td>
          <td>{{pladetobs.idPlaDetObs}}</td>
          <td>{{pladetobs.idPlanillaDet}}</td>
          <td>{{pladetobs.idObservacion}}</td>
          <td>{{pladetobs.idRespuesta}}</td>
          <td>{{pladetobs.descripcion}}</td>
          <td>{{pladetobs.respuesta}}</td>
          <td>{{pladetobs.estado}}</td>
          <td>{{pladetobs.observacionDescripcion}}</td>
          <td>{{pladetobs.respuestaDescripcion}}</td>
          <td>{{pladetobs.planillaDetDescripcion}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteRespuesta(pladetobs.idPlaDetObs)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idPlaDetObs" class="form-label">IdPlaDetObs</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPlaDetObs" name="idPlaDetObs" v-model="datoPlaDetObs.idPlaDetObs" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idPlanillaDet" class="form-label"> Planilla Det</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPlanillaDet" name="idPlanillaDet" v-model="datoPlaDetObs.idPlanillaDet">
                      <option v-for="planillaDet in planillaDets" :value="planillaDet.idPlanillaDet" :key="planillaDet.idPlanillaDet">
                        {{ planillaDet.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idObservacion" class="form-label"> Observacion</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idObservacion" name="idObservacion" v-model="datoPlaDetObs.idObservacion">
                      <option v-for="observacion in observacions" :value="observacion.idObservacion" :key="observacion.idObservacion">
                        {{ observacion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idRespuesta" class="form-label">IdRespuesta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idRespuesta" name="idRespuesta" v-model="datoPlaDetObs.idRespuesta" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripcion</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="descripcion" name="descripcion" v-model="datoPlaDetObs.descripcion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="respuesta" class="form-label">Respuesta</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="respuesta" name="respuesta" v-model="datoPlaDetObs.respuesta" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarPlaDetObs" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPlaDetObs" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      respuestas : [],
      datoRespuesta : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idRespuesta: '',
// Variables master
// Variables details
      pladetobss : [],
      datoPlaDetObs : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      planillaDets : [],
      observacions : [],
      // respuestas : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idRespuesta = this.$route.params.p_idrespuesta
    this.abrirEditar(this.p_idRespuesta)
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'descripcion'
      ];
      const requiredFieldsText = [
        'descripcion'
      ];
      return validarForm(this.datoRespuesta, requiredFields, requiredFieldsText);
    },
    async guardarRespuesta(){
      if(this.validarForm() === 1){
        try {
          await api.post('/respuestas', this.datoRespuesta)
          swal("Correcto!", "Respuesta creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditRespuesta(){
      if(this.validarForm() === 1){
        try {
          await api.post('/respuestas', this.datoRespuesta)
          swal("Correcto!", "Respuesta creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoRespuesta={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idRespuesta){
      this.modalWindow = true
      if(idRespuesta != null){    
           api.get('/vwrespuestas/'+idRespuesta).then(resp=>{
          this.datoRespuesta = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarRespuesta(){
      this.$router.push('/Respuesta')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.pladetobss.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwpladetobss/nombre/'+this.nombreBusqueda).then(response=>{
          this.pladetobss=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.pladetobss.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwpladetobss').then(response=>{
      this.pladetobss=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.pladetobss.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'descripcion'
      ];
      const requiredFieldsText = [
        'descripcion'
      ];
      return validarForm(this.datoRespuesta, requiredFields, requiredFieldsText);
    },
    async guardarPlaDetObs(){
      if(this.validarForm() === 1){
        try {
          this.datoPlaDetObs.idRespuesta = this.datoRespuesta.idRespuesta;
          await api.post('/pladetobss', this.datoPlaDetObs)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "PlaDetObs creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPlaDetObs(){
      if(this.validarForm() === 1){
        try {
          await api.post('/pladetobss', this.datoPlaDetObs)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "PlaDetObs creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoPlaDetObs={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idPlaDetObs){
      this.modalWindow = true
      if(idPlaDetObs != null){    
           api.get('/vwpladetobss/'+idPlaDetObs).then(resp=>{
          this.datoPlaDetObs = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idPlaDetObs){
      this.modalWindow = true
      if(idPlaDetObs != null){
        this.$router.push('/pladetobsmd/'+idPlaDetObs)
      }
    },
    async deletePlaDetObs (idPlaDetObs) {
      try{
        await api.delete('/pladetobss/'+idPlaDetObs)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchPlanillaDets() {
      fetch('http://localhost:8080/api/v1/planilladets')
        .then(response => response.json())
        .then(data => {
          this.planillaDets = data;
        })
        .catch(error => {
          console.error('Error fetching planillaDets:', error);
        });
    },
    fetchObservacions() {
      fetch('http://localhost:8080/api/v1/observacions')
        .then(response => response.json())
        .then(data => {
          this.observacions = data;
        })
        .catch(error => {
          console.error('Error fetching observacions:', error);
        });
    },
/*     fetchRespuestas() {
      fetch('http://localhost:8080/api/v1/respuestas')
        .then(response => response.json())
        .then(data => {
          this.respuestas = data;
        })
        .catch(error => {
          console.error('Error fetching respuestas:', error);
        });
    }, */
  },
}
</script>
